import { parseJwt } from "./auth";

export const Permissoes = {
  ClienteVisualizar: "cliente.visualizar",
  ClienteCadastrar: "cliente.cadastrar",
  LicencaVisualizar: "licenca.visualizar",
  LicencaGerar: "licenca.gerar",
  LicencaEditar: "licenca.editar",
  LicencaCancelar: "licenca.cancelar",
  UsuarioGerir: "usuario.gerir",
  RelatorioAcessar: "relatorio.acessar",
  VendedorGerir: "vendedor.gerir",
  AuditoriaAcessar: "auditoria.acessar",
};

export function isSystemUser(token) {
  const payload = parseJwt(token);
  const raw = payload?.SystemUser;
  return raw === true || raw === "true";
}

export function getPermissionsFromToken(token) {
  if (!token) return [];

  const stored = sessionStorage.getItem("permissoes");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch {
      /* ignore */
    }
  }

  if (isSystemUser(token)) return Object.values(Permissoes);

  const payload = parseJwt(token);
  if (!payload) return [];

  const raw = payload.permission ?? payload.permissions ?? [];
  if (Array.isArray(raw)) return raw;
  return raw ? [raw] : [];
}

export function hasPermission(token, code) {
  if (!code) return true;
  const stored = sessionStorage.getItem("permissoes");
  if (isSystemUser(token) && !stored) return true;
  return getPermissionsFromToken(token).includes(code);
}

export function hasAnyPermission(token, codes = []) {
  if (!codes?.length) return true;
  return codes.some((c) => hasPermission(token, c));
}

export function persistAuthExtras({ permissoes, perfil } = {}) {
  if (Array.isArray(permissoes)) {
    sessionStorage.setItem("permissoes", JSON.stringify(permissoes));
  }
  if (perfil) {
    sessionStorage.setItem("perfil", perfil);
  }
}

export function clearAuthExtras() {
  sessionStorage.removeItem("permissoes");
  sessionStorage.removeItem("perfil");
}
